import Phaser from "phaser";
import { IMAGES, SOUNDS } from "../assets";
import { setAppState } from "./boot-scene";
import { SceneKey } from "./scene-keys";

/** Loads every asset from the manifest, then starts the game scene. */
export class PreloadScene extends Phaser.Scene {
	private readonly failed: string[] = [];

	constructor() {
		super(SceneKey.Preload);
	}

	preload(): void {
		this.load.setPath("assets");
		for (const [key, path] of Object.entries(IMAGES)) this.load.image(key, path);
		// Without Web Audio, Phaser's HTML5 Audio fallback may never fire load events (seen in
		// Playwright's Windows WebKit) and stall the loader: play silently instead. Code that plays
		// sounds must check `this.cache.audio.exists(key)`.
		if (this.sound instanceof Phaser.Sound.WebAudioSoundManager) {
			for (const [key, path] of Object.entries(SOUNDS)) this.load.audio(key, path);
		}
		this.load.on(Phaser.Loader.Events.FILE_LOAD_ERROR, (file: Phaser.Loader.File) => {
			this.failed.push(file.key);
		});
	}

	create(): void {
		if (this.failed.length > 0) {
			setAppState("error");
			console.error(`Failed to load assets: ${this.failed.join(", ")}`);
			return;
		}
		setAppState("ready");
		this.scene.start(SceneKey.Game);
	}
}
